import React from 'react';
import { Box, Button, Modal, Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const WarningModal = ({ open, handleModalClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 300,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          sx={{
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          Clear Ship to Party Details?
        </Typography>
        <Typography
          id='modal-modal-title'
          variant='h6'
          sx={{
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          Your Ship to Party details will be cleared if you go back. Do you want
          to clear them and go back?
        </Typography>

        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ marginTop: '2rem' }}
        >
          <Button
            variant='outlined'
            color='error'
            onClick={() => handleModalClose()}
          >
            Cancel
          </Button>
          <Button
            variant='outlined'
            color='primary'
            onClick={() => {
              dispatch({ type: 'RESET_BCM_ORDER' });
              navigate('/order-booking/po-select-industry');
            }}
          >
            Confirm
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default WarningModal;
